import {toast} from "react-toastify";
import {Col, CustomInput, FormGroup, Input} from "reactstrap";
import {get} from "lodash";
import ReactTable from "react-table";
import React from "react";
import {Spinner} from "reactstrap";

export const getFileUrl = (fileName) => {
  const fileUrl = process.env.REACT_APP_DOMAIN_FILE_URL + fileName;
  return fileUrl
}
export const setToastSuccess = (message = '🦄Add Product Successfully!') => {
  toast.success(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}
export const toastMessage = (type, message) => {
  toast[type](message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}
export const keyDesignCustomcat = {
  front: {
    key: "design_url",
    preset_id: "",
  },
  both: {
    key: "design_url",
    preset_id: 4,
  },
  back: {
    key: "design_url_back",
    preset_id: "",
  },
  wholeT: {
    key: "design_url",
    preset_id: "",
  },
  wholeNT: {
    key: "design_url",
    preset_id: 2,
  },
};
export const optionRecipient = [
  {value: 'men', label: 'Men'},
  {value: 'women', label: 'Women'},
  {value: 'unisex_adults', label: 'Unisex adults'},
  {value: 'teen_boys', label: 'Teen boys'},
  {value: 'teen_girls', label: 'Teen girls'},
  {value: 'teens', label: 'Teens'},
  {value: 'boys', label: 'Boys'},
  {value: 'girls', label: 'Girls'},
  {value: 'children', label: 'Children'},
  {value: 'baby_boys', label: 'Baby boys'},
  {value: 'baby_girls', label: 'Baby girls'},
  {value: 'babies', label: 'Babies'},
  {value: 'birds', label: 'Birds'},
  {value: 'cats', label: 'Cats'},
  {value: 'dogs', label: 'Dogs'},
  {value: 'pets', label: 'Pets'},
  {value: 'not_specified', label: 'Not specified'},
];
export const optionOccasion = [
  {value: 'anniversary', label: 'Anniversary'},
  {value: 'baptism', label: 'Baptism'},
  {value: 'bar_or_bat_mitzvah', label: 'Bar or bat mitzvah'},
  {value: 'birthday', label: 'Birthday'},
  {value: 'canada_day', label: 'Canada day'},
  {value: 'chinese_new_year', label: 'Chinese new year'},
  {value: 'cinco_de_mayo', label: 'Cinco de mayo'},
  {value: 'confirmation', label: 'Confirmation'},
  {value: 'christmas', label: 'Christmas'},
  {value: 'day_of_the_dead', label: 'Day of the dead'},
  {value: 'easter', label: 'Easter'},
  {value: 'eid', label: 'Eid'},
  {value: 'engagement', label: 'Engagement'},
  {value: 'fathers_day', label: 'Fathers day'},
  {value: 'get_well', label: 'Get well'},
  {value: 'graduation', label: 'Graduation'},
  {value: 'halloween', label: 'Halloween'},
  {value: 'hanukkah', label: 'Hanukkah'},
  {value: 'housewarming', label: 'Housewarming'},
  {value: 'kwanzaa', label: 'Kwanzaa'},
  {value: 'prom', label: 'Prom'},
  {value: 'july_4th', label: 'July 4th'},
  {value: 'mothers_day', label: 'Mothers day'},
  {value: 'new_baby', label: 'New baby'},
  {value: 'new_years', label: 'New years'},
  {value: 'quinceanera', label: 'Quinceanera'},
  {value: 'retirement', label: 'Retirement'},
  {value: 'st_patricks_day', label: 'St patricks day'},
  {value: 'sweet_16', label: 'Sweet 16'},
  {value: 'sympathy', label: 'Sympathy'},
  {value: 'thanksgiving', label: 'Thanksgiving'},
  {value: 'valentines', label: 'Valentines'},
  {value: 'wedding', label: 'Wedding'}
];
export const whoMade = [
  {value: null, label: 'Who made it?'},
  {value: 'i_did', label: 'I did'},
  {value: 'collective', label: 'A member of my shop'},
  {value: 'someone_else', label: 'Another company or person'}
];

export const whatIsIt = [
  {value: null, label: 'What is it?'},
  {value: 'i_did', label: 'A finished product'},
  {value: 'collective', label: 'A supply or tool to make things'}
];

export const whenMade = [
  {value: null, label: 'When was made it?'},
  {value: 'made_to_order', label: 'Made to order'},
  {value: '2020_2021', label: '2020-2021'},
  {value: '2010_2019', label: '2010-2019'},
  {value: '2002_2009', label: '2002-2009'},
  {value: 'before_2002', label: 'Before 2002'},
  {value: '2000_2001', label: '2000-2001'},
  {value: '1990s', label: '1990s'},
  {value: '1980s', label: '1980s'},
  {value: '1970s', label: '1970s'},
  {value: '1960s', label: '1960s'},
  {value: '1950s', label: '1950s'},
  {value: '1940s', label: '1940s'},
  {value: '1930s', label: '1930s'},
  {value: '1920s', label: '1920s'},
  {value: '1910s', label: '1910s'},
  {value: '1900s', label: '1900-1909'},
  {value: '1800s', label: '1800s'},
  {value: '1700s', label: '1700s'},
  {value: 'before_1700', label: 'Before 1700'},
];

export const variantTest = [
  {
    "property_id": 200,
    "name": "Primary color",
    "display_name": "Primary color",
    "is_required": 0,
    "supports_attributes": true,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 52047899002,
    "name": "Secondary color",
    "display_name": "Secondary color",
    "is_required": 0,
    "supports_attributes": true,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [
      {
        "value_id": 1213,
        "name": "Beige",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1,
        "name": "Black",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 2,
        "name": "Blue",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1216,
        "name": "Bronze",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 3,
        "name": "Brown",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1219,
        "name": "Clear",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1218,
        "name": "Copper",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1214,
        "name": "Gold",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5,
        "name": "Gray",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 4,
        "name": "Green",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 6,
        "name": "Orange",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 7,
        "name": "Pink",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 8,
        "name": "Purple",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1220,
        "name": "Rainbow",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 9,
        "name": "Red",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1217,
        "name": "Rose gold",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1215,
        "name": "Silver",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 10,
        "name": "White",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 11,
        "name": "Yellow",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      }
    ],
    "selected_values": []
  },
  {
    "property_id": 570246211881,
    "name": "Accessory style",
    "display_name": "Style",
    "is_required": 0,
    "supports_attributes": true,
    "supports_variations": 0,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [
      {
        "value_id": 2409,
        "name": "Gothic",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 2393,
        "name": "Minimalist",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 2555,
        "name": "Rocker",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 2557,
        "name": "Utility",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      }
    ],
    "selected_values": []
  },
  {
    "property_id": 504,
    "name": "Diameter",
    "display_name": "Diameter",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 341,
        "display_name": "Inches",
        "description": "Inches"
      },
      {
        "scale_id": 342,
        "display_name": "Centimeters",
        "description": "Centimeters"
      },
      {
        "scale_id": 343,
        "display_name": "Other",
        "description": "Other"
      }
    ],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 501,
    "name": "Dimensions",
    "display_name": "Dimensions",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 344,
        "display_name": "Inches",
        "description": "Inches"
      },
      {
        "scale_id": 345,
        "display_name": "Centimeters",
        "description": "Centimeters"
      },
      {
        "scale_id": 346,
        "display_name": "Other",
        "description": "Other"
      }
    ],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 502,
    "name": "Fabric",
    "display_name": "Fabric",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 500,
    "name": "Finish",
    "display_name": "Finish",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 503,
    "name": "Flavor",
    "display_name": "Flavor",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 505,
    "name": "Height",
    "display_name": "Height",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 347,
        "display_name": "Inches",
        "description": "Inches"
      },
      {
        "scale_id": 348,
        "display_name": "Centimeters",
        "description": "Centimeters"
      },
      {
        "scale_id": 349,
        "display_name": "Other",
        "description": "Other"
      }
    ],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 506,
    "name": "Length",
    "display_name": "Length",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 350,
        "display_name": "Inches",
        "description": "Inches"
      },
      {
        "scale_id": 351,
        "display_name": "Centimeters",
        "description": "Centimeters"
      },
      {
        "scale_id": 352,
        "display_name": "Other",
        "description": "Other"
      }
    ],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 507,
    "name": "Material",
    "display_name": "Material",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 508,
    "name": "Pattern",
    "display_name": "Pattern",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 509,
    "name": "Scent",
    "display_name": "Scent",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 100,
    "name": "TeeShirtSize",
    "display_name": "Size",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 301,
        "display_name": "Alpha",
        "description": "Alpha"
      },
      {
        "scale_id": 327,
        "display_name": "Inches",
        "description": "Inches"
      },
      {
        "scale_id": 328,
        "display_name": "Centimeters",
        "description": "Centimeters"
      },
      {
        "scale_id": 335,
        "display_name": "Fluid Ounces",
        "description": "Fluid Ounces"
      },
      {
        "scale_id": 336,
        "display_name": "Millilitres",
        "description": "Millilitres"
      },
      {
        "scale_id": 337,
        "display_name": "Litres",
        "description": "Litres"
      },
      {
        "scale_id": 329,
        "display_name": "Other",
        "description": "Other"
      }
    ],
    "possible_values": [
      {
        "value_id": 1166388104,
        "name": "XXS",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1166388106,
        "name": "XS",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1166388112,
        "name": "S",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1166388116,
        "name": "M",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1166388122,
        "name": "L",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1166388126,
        "name": "XL",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1166388128,
        "name": "XXL",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1502041605,
        "name": "3XL",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1502041607,
        "name": "4XL",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 1502041613,
        "name": "5XL",
        "scale_id": 301,
        "equal_to": [],
        "order": 0
      }
    ],
    "selected_values": []
  },
  {
    "property_id": 510,
    "name": "Style",
    "display_name": "Style",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 511,
    "name": "Weight",
    "display_name": "Weight",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 332,
        "display_name": "Pounds",
        "description": "Pounds"
      },
      {
        "scale_id": 331,
        "display_name": "Ounces",
        "description": "Ounces"
      },
      {
        "scale_id": 333,
        "display_name": "Grams",
        "description": "Grams"
      },
      {
        "scale_id": 334,
        "display_name": "Kilograms",
        "description": "Kilograms"
      }
    ],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 512,
    "name": "Width",
    "display_name": "Width",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [
      {
        "scale_id": 338,
        "display_name": "Inches",
        "description": "Inches"
      },
      {
        "scale_id": 339,
        "display_name": "Centimeters",
        "description": "Centimeters"
      },
      {
        "scale_id": 340,
        "display_name": "Other",
        "description": "Other"
      }
    ],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 515,
    "name": "Device",
    "display_name": "Device",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [
      {
        "value_id": 5668983248,
        "name": "iPad",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983250,
        "name": "iPad Mini",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983258,
        "name": "iPhone 5",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5745757057,
        "name": "iPhone 4/4S",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983226,
        "name": "Kindle Fire HD",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983232,
        "name": "Kindle Fire HD 8.9\"",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983234,
        "name": "Kindle Paperwhite",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983240,
        "name": "Samsung Galaxy S4",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      },
      {
        "value_id": 5668983238,
        "name": "Samsung Galaxy S3",
        "scale_id": null,
        "equal_to": [],
        "order": 0
      }
    ],
    "selected_values": []
  },
  {
    "property_id": 513,
    "name": "Custom1",
    "display_name": "Custom Property",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  },
  {
    "property_id": 514,
    "name": "Custom2",
    "display_name": "Custom Property",
    "is_required": 0,
    "supports_attributes": 0,
    "supports_variations": true,
    "is_multivalued": 0,
    "scales": [],
    "possible_values": [],
    "selected_values": []
  }
];
export const returnCurrentPage = (total, pageInfo) => {
  // if (isCheckbox) columns.splice(0, 0, checkBoxColumns);
  let currentPage = 0;
  if (Math.ceil(total / pageInfo.pageSize) < pageInfo.pageIndex + 1) {
    currentPage = Math.ceil(pageInfo.total / pageInfo.pageSize);
  } else {
    currentPage = pageInfo.pageIndex;
  }
  return currentPage;
}
export const keyDesignGearmentConvert = {
  front: "design_link",
  whole: "design_link",
  back: "design_link_back",
};
export const joinStringTwoArray = (arr1, arr2, op) => {
  let result = [];
  for (let i = 0; i < arr1.length; i++) {
    arr2.forEach(item => {
      if (op) {
        result.push(arr1[i] + "/" + item)
      } else {
        result.push(arr1[i] + "/" + item)
      }
    })
  }
  return result;
}

export function setStorage(key, value, expires) {

  if (expires === undefined || expires === null) {
    expires = (24 * 60 * 60);  // default: seconds for 1 day
  } else {
    expires = Math.abs(expires); //make sure it's positive
  }

  let now = Date.now();  //millisecs since epoch time, lets deal only with integer
  let schedule = now + expires * 1000;
  try {
    localStorage.setItem(key, value);
    localStorage.setItem(key + '_expiresIn', schedule);
  } catch (e) {
    console.log('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e));
    return false;
  }
  return true;
}

export function toastCustom(message, type, position = "top-center") {
  switch (type) {
    case "success":
      toast.success(message, {
        position,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    case "error":
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    case "warn":
      toast.warn(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      break;
    default:
      break;
  }
}

export const handleChangeTags = (tags) => {
  let arrayTagSplit = [];
  let result = tags.filter(tag => !tag.includes(','));
  let splitTag = tags.find(tag => tag.includes(','));
  if (splitTag) {
    arrayTagSplit = splitTag.split(',');
  }
  result = [...arrayTagSplit, ...result];
  return [...new Set(result)];
}
export const allCountries = [
  {name: 'French', code: 'FR'},
  {name: 'German', code: 'DE'},
  {name: 'Italian', code: 'IT'},
  {name: 'Dutch', code: 'NL'},
  {name: 'English', code: 'EN'},
  {name: 'Japanese', code: 'JA'},
  {name: 'Polish', code: 'PL'},
  {name: 'Portuguese', code: 'PT'},
  {name: 'Russian', code: 'RU'},
  {name: 'Spanish', code: 'ES'},
];

export const hasSameObject = (obj1, obj2) => {
  return !!((obj1.price && obj2.price) || (obj1.is_enabled && obj2.is_enabled) || (obj1.quantity && obj2.quantity));
};

const cellPrice = ({original, index}, key, onchangePrice, isNotSame) => {
  return (
    <Input
      type={key !== "sku" ? "number" : "text"}
      value={original[key]}
      onChange={(e) => onchangePrice(e, original, index, key, isNotSame)}
    />
  );
};

export const renderVariations = (listProductVariations, onchangePrice, switchEnable, options) => {
  const columns = [
    {
      Header: (
        <CustomInput
          type="checkbox"
          className="input-checkbox full-wrap small"
          id={`test-all`}
        />
      ),
      headerClassName: "select-column",
      className:
        "p-0 select-cell d-flex align-items-center justify-content-center",
      accessor: "_id",
      filterable: false,
      sortable: false,
      width: 45,
      resizable: false,
      Cell: (d) => {
        const {original} = d;
        return (
          <CustomInput
            type="checkbox"
            id={`checkbox-${original.value}`}
            className="input-checkbox full-wrap small"
          />
        );
      }
    }
  ]
  let data = get(options[0], "values", []).map((item, index) => ({
    option1: typeof item === "string" ? item : item.label,
    value: typeof item === "string" ? item : item.value,
    property_id: options[0].value,
    price: get(listProductVariations[index], "offerings[0].price", 0),
    quantity: get(listProductVariations[index], "offerings[0].quantity", 0),
    sku: get(listProductVariations[index], "sku", ""),
  }));
  const returnOptionName = (prop) => {
    let option = options.find(op => op.value === prop?.property_id);
    return prop?.values.length ? prop?.values[0] : get(option?.list_item.find(li => li.value_id === prop.value_ids[0]), "name", "")
  }
  if (options.length > 1) {
    if (hasSameObject(options[0], options[1])) {

      let addMoreColumns = [
        {
          Header: options[0].property_name || options[0].label,
          accessor: "option1",
          className: "d-flex justify-content-center align-items-center",
        },
        {
          Header: options[1].property_name || options[1].label,
          accessor: "option2",
          className: "d-flex justify-content-center align-items-center",
        },
        ...(options[0].price ? [{
          Header: "Price",
          accessor: "price",
          className: "d-flex justify-content-center align-items-center",
          Cell: row => cellPrice(row, "price", onchangePrice)
        }] : []),
        ...(options[0].quantity ? [{
          Header: "Quantity",
          accessor: "quantity",
          className: "d-flex justify-content-center align-items-center",
          Cell: row => cellPrice(row, "quantity", onchangePrice)
        }] : []),
        ...(options[0].sku ? [{
          Header: "Sku",
          accessor: "sku",
          className: "d-flex justify-content-center align-items-center",
          Cell: row => cellPrice(row, "sku", onchangePrice)
        }] : [])
      ]
      columns.splice(1, 0, ...addMoreColumns);

      data = listProductVariations.map(item => (
        {
          option1: returnOptionName(item.property_values[0]),
          value: item.property_values[0].property_id,
          option2: returnOptionName(item.property_values[1]),
          price: get(item, "offerings[0].price", 0),
          quantity: get(item, "offerings[0].quantity", 0),
          sku: get(item, "sku", ""),
        }
      ));

      return <ReactTable
        data={data}
        defaultFilterMethod={(filter, row) => {
          return String(row[filter._id]) === filter.value;
        }}
        showPaginationBottom={data.length > 10}
        manual
        columns={columns}
        minRows={5}
        className="-striped -highlight"
      />
    } else {
      let newColumns = {
        0: [
          {
            Header: options[0].property_name || options[0].label,
            accessor: "option1",
            className: "d-flex justify-content-center align-items-center",
          },
          ...(options[0].price ? [{
            Header: "Price",
            className: "d-flex justify-content-center align-items-center",
            Cell: row => cellPrice(row, "price", onchangePrice, "notSame")
          }] : []),
          ...(options[0].quantity ? [{
            Header: "Quantity",
            className: "d-flex justify-content-center align-items-center",
            Cell: row => cellPrice(row, "quantity", onchangePrice, "notSame")
          }] : []),
          ...(options[0].sku ? [{
            Header: "Sku",
            className: "d-flex justify-content-center align-items-center",
            Cell: row => cellPrice(row, "sku", onchangePrice, "notSame")
          }] : [])
        ],
        1: [
          {
            Header: options[1].property_name || options[1].label,
            accessor: "option1",
            className: "d-flex justify-content-center align-items-center",
          },
          ...(options[1].price ? [{
            Header: "Price",
            className: "d-flex justify-content-center align-items-center",
            Cell: row => cellPrice(row, "price", onchangePrice, "notSame")
          }] : []),
          ...(options[1].quantity ? [{
            Header: "Quantity",
            className: "d-flex justify-content-center align-items-center",
            Cell: row => cellPrice(row, "quantity", onchangePrice, "notSame")
          }] : []),
          ...(options[1].sku ? [{
            Header: "Sku",
            className: "d-flex justify-content-center align-items-center",
            Cell: row => cellPrice(row, "sku", onchangePrice, "notSame")
          }] : [])
        ]
      };

      return options.map((op, index) => {

        const newData = {
          0: options[0].values?.map(item => {
            let value = typeof item === "string" ? item : item.value;
            return {
              option1: typeof item === "string" ? item : item.label,
              value,
              property_id: op.value,
              price: get(listProductVariations.find(dv => dv.property_values.some(i => i.property_id === op.value && (i.value_ids.includes(value) || i.values.includes(value)))), "offerings[0].price", 0),
              quantity: get(listProductVariations.find(dv => dv.property_values.some(i => i.property_id === op.value && (i.value_ids.includes(value) || i.values.includes(value)))), "offerings[0].quantity", 0),
              sku: get(listProductVariations.find(dv => dv.property_values.some(i => i.property_id === op.value && (i.value_ids.includes(value) || i.values.includes(value)))), "sku", ""),
            }
          }),
          1: options[1].values?.map(item => {
            let value = typeof item === "string" ? item : item.value;
            return {
              option1: typeof item === "string" ? item : item.label,
              value,
              property_id: op.value,
              price: get(listProductVariations.find(dv => dv.property_values.some(i => i.property_id === op.value && (i.value_ids.includes(value) || i.values.includes(value)))), "offerings[0].price", 0),
              quantity: get(listProductVariations.find(dv => dv.property_values.some(i => i.property_id === op.value && (i.value_ids.includes(value) || i.values.includes(value)))), "offerings[0].quantity", 0),
              sku: get(listProductVariations.find(dv => dv.property_values.some(i => i.property_id === op.value && (i.value_ids.includes(value) || i.values.includes(value)))), "sku", ""),
            }
          })
        }
        let columnsOption = [...columns];
        columnsOption.splice(1, 0, ...newColumns[`${index}`])
        return <FormGroup row key={index}>
          <Col md="12">
            <h2>{op.label}</h2>
            <ReactTable
              data={newData[`${index}`]}
              style={{minHeight: 200}}
              defaultFilterMethod={(filter, row) => {
                return String(row[filter._id]) === filter.value;
              }}
              showPaginationBottom={newData[`${index}`].length > 10}

              manual
              columns={columnsOption}
              minRows={5}
              className="-striped -highlight"
            />
          </Col>

        </FormGroup>

      })
    }
  }

  let defaultColumns = [
    {
      Header: options[0].property_name || get(options[0], "label", ""),
      accessor: "option1",
      className: "d-flex justify-content-center align-items-center",
    },
    ...(options[0]?.price ? [{
      Header: "Price",
      className: "d-flex justify-content-center align-items-center",
      Cell: row => cellPrice(row, "price", onchangePrice, "notSame")
    }] : []),
    ...(options[0]?.quantity ? [{
      Header: "Quantity",
      className: "d-flex justify-content-center align-items-center",
      Cell: row => cellPrice(row, "quantity", onchangePrice, "notSame")
    }] : []),
    ...(options[0].sku ? [{
      Header: "Sku",
      className: "d-flex justify-content-center align-items-center",
      Cell: row => cellPrice(row, "sku", onchangePrice, "notSame")
    }] : [])
  ];
  columns.splice(1, 0, ...defaultColumns);
  return <ReactTable
    data={data}
    defaultFilterMethod={(filter, row) => {
      return String(row[filter._id]) === filter.value;
    }}
    manual
    columns={columns}
    minRows={5}
    className="-striped -highlight"
  />
}

export const Loading = () => {
  return <div className="d-flex justify-content-center">
    <Spinner type="grow" color="secondary" size="sm" className="mr-1"/>
    <Spinner type="grow" color="secondary" size="sm" className="mr-1"/>
    <Spinner type="grow" color="secondary" size="sm" className="mr-1"/>
    <Spinner type="grow" color="secondary" size="sm" className="mr-1"/>
    <Spinner type="grow" color="secondary" size="sm" className="mr-1"/>
  </div>
}


